// import Vue from 'vue'
// import Router from 'vue-router'
// import Home from './views/Home.vue'
// import Trabajo from './views/Trabaja.vue'
// import Programa from './views/Programa.vue'

// Vue.use(Router)

// export default new Router({
//   mode: 'history',
//   base: process.env.BASE_URL,
//   routes: [
//     {
//       path: '/',
//       name: 'home',
//       component: Home,
//     },
//     {
//       path: '/trabaja-nosotros',
//       name: 'trabaja-con-nosotros',
//       component: Trabajo,
//     },
//     {
//       path: '/programa-integridad',
//       name: 'programa-integridad',
//       component: Programa,
//     },
//   ],
// })
import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Trabajo from './views/Trabaja.vue'
import Programa from './views/Programa.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/trabaja-nosotros',
      name: 'trabaja-con-nosotros',
      component: Trabajo,
    },
    {
      path: '/programa-integridad',
      name: 'programa-integridad',
      component: Programa,
    },
  ],

  // 👇 Esto hace que siempre comience desde arriba al cambiar de ruta
  // scrollBehavior(to, from, savedPosition) {
  //   if (savedPosition) {
  //     return savedPosition
  //   } else {
  //     return { x: 0, y: 0 } // Usa x/y en Vue Router 3 (no top)
  //     // Si querés desplazamiento suave (no nativo): podés usar window.scrollTo en afterEach
  //   }
  // },
  scrollBehavior(to, from, savedPosition) {
    console.log(from, savedPosition)
    if (to.hash) {
      return { selector: to.hash }
    }
    return { top: 0 }
  },
})
